import AnswerColumn from "../../api/types/AnswerColumn";
import {v4 as uuid} from "uuid";

export default function createAnswerRow(columns: AnswerColumn[] = []) {
    return {
        identity: uuid(),
        columns
    }
}
